import { SquareIcon } from 'assests/GmsIcons';
import React from 'react';

type LegendItem = {
    name: string;
    strokeColor: string;
    fillColor: string;
};

type LegendsProps = {
    items: LegendItem[];
};

const Legends = ({ items }: LegendsProps) => {
    if (!items.length) return null;
    return (
        <div className='tw-flex tw-items-center tw-gap-6 tw-mt-6'>
            {items.map((item) => (
                <div key={item.name} className='tw-flex tw-items-center tw-gap-3'>
                    <SquareIcon strokColor={item.strokeColor} filColor={item.fillColor} />
                    <label className='tw-text-ink tw-text-sm'>{item.name}</label>
                </div>
            ))}
        </div>
    );
};

export default Legends;